import { getDocument } from '@atlaskit/browser-apis';
import type { EditorState } from '@atlaskit/editor-prosemirror/state';
import { Decoration, DecorationSet } from '@atlaskit/editor-prosemirror/view';
import { token } from '@atlaskit/tokens';

import type { EligibleRange } from './types';

/**
 * Create a DecorationSet containing the nudge widget at the end
 * of the eligible paragraph node.
 *
 * @param state - Current editor state
 * @param range - The eligible node range { from, to }
 * @returns A DecorationSet with the nudge widget
 */
export function createNudgeDecorationSet({
	state,
	range,
}: {
	range: EligibleRange;
	state: EditorState;
}): DecorationSet {
	const widget = () => {
		const doc = getDocument();
		if (!doc) {
			throw new Error('Document not found');
		}

		const container = doc.createElement('div');
		container.setAttribute('data-testid', 'ai-quick-prompt-placeholder-decoration');
		container.className =
			'placeholder-decoration placeholder-decoration-fade-in placeholder-decoration-inline ai-quick-prompt-placeholder-decoration';

		// TODO: EDITOR-5728 - i18n will be added later
		const tabSpan = doc.createElement('span');
		tabSpan.textContent = 'Tab';
		tabSpan.className = 'code';
		tabSpan.style.setProperty('color', token('color.text.subtlest'));
		container.appendChild(tabSpan);

		const span = doc.createElement('span');
		span.textContent = ' to improve writing';
		container.appendChild(span);

		return container;
	};

	return DecorationSet.create(state.doc, [
		Decoration.widget(range.to, widget, {
			side: 1, // After the content
			key: 'ai-quick-prompt-nudge',
		}),
	]);
}
